import React from 'react';

function AccountsStatus({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill={color}
                fillRule="evenodd"
                d="M16 16.956c0 .576-.448 1.044-1 1.044h-1.512a.256.256 0 0 1-.25-.26V15.53a.512.512 0 0 0-.5-.522h-2.463c-.276 0-.5.234-.5.522v2.208c0 .144-.112.261-.25.261H8c-.551 0-1-.468-1-1.044V7.043C7 6.468 7.449 6 8 6h7c.552 0 1 .468 1 1.043v9.913Zm-5.539-1.206h2.078V18H10.46v-2.25Zm4.154-8.25h-1.384V9h1.384V7.5Zm0 2.625h-1.384v1.5h1.384v-1.5Zm0 2.625h-1.384v1.5h1.384v-1.5Zm-3.807 0h1.384v1.5h-1.384v-1.5Zm1.384-2.625h-1.384v1.5h1.384v-1.5ZM8.385 12.75h1.384v1.5H8.385v-1.5Zm2.423-5.25h1.384V9h-1.384V7.5Zm-1.039 0H8.385V9h1.384V7.5Zm-1.384 2.625h1.384v1.5H8.385v-1.5Z"
                clipRule="evenodd"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="m23 8.358-1.846.445C19.695 2.99 14.081-.288 8.61 1.478 3.14 3.245-.11 9.384 1.35 15.198c1.264 5.035 5.33 7.577 9.32 7.841 5.312.509 9.941-2.75 10.65-7.736l-2.644-.557c-.375 2.978-3.22 5.261-6.545 5.652-3.575.235-7.378-2.304-8.306-6-1.093-4.353 1.348-8.966 5.446-10.29 4.097-1.322 8.315 1.14 9.408 5.494l-1.88.956 4.51 2.75L23 8.358Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default AccountsStatus;
